import React, { useState, useEffect } from "react";
import { ScrollText, ShieldAlert } from "lucide-react";

const KEY = "baaki_disclaimer_accepted_v1";

export default function DisclaimerGate({ children }) {
  const [accepted, setAccepted] = useState(true);

  useEffect(() => {
    setAccepted(localStorage.getItem(KEY) === "yes");
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "yes");
    setAccepted(true);
  };

  return (
    <>
      {children}
      {!accepted && (
        <div
          data-testid="disclaimer-gate"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm px-4"
        >
          <div className="w-full max-w-lg bg-white border border-border doc-shadow animate-rise">
            <div className="border-b border-border px-7 py-5 flex items-center gap-3">
              <ScrollText className="h-5 w-5 text-signal" strokeWidth={1.5} />
              <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
                KashBaaki · Notice to User
              </span>
            </div>
            <div className="px-7 py-7">
              <h2 className="font-serif text-3xl font-semibold tracking-tight text-ink">
                Informational tool, not legal advice
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
                Baaki helps Micro &amp; Small Enterprises organise overdue-payment cases and
                estimate statutory interest under the MSMED Act, 2006. The calculations,
                notices and case guidance provided are informational only and do not
                constitute legal advice, nor create an advocate–client relationship.
              </p>
              <div className="mt-5 flex items-start gap-3 bg-danger-bg border border-danger/30 px-4 py-3">
                <ShieldAlert className="h-4 w-4 text-danger mt-0.5 shrink-0" strokeWidth={1.5} />
                <p className="text-[13px] leading-relaxed text-ink">
                  Always consult a qualified advocate before serving a demand notice or filing
                  before the MSEFC / Samadhaan. Figures shown in this demo use sample data.
                </p>
              </div>
              <button
                data-testid="disclaimer-accept-btn"
                onClick={accept}
                className="mt-6 w-full bg-ink text-white font-medium text-sm py-3 hover:-translate-y-[1px] hover:bg-black transition-transform duration-150"
              >
                I Understand &amp; Accept
              </button>
              <p className="mt-3 text-center font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                Acceptance is recorded for this browser
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
